import React, { Fragment, useState } from 'react';
import { Button, IconButton, Typography } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import { toJS } from 'mobx';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useRootStore } from '../../../stores/BridgeProvider';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';
import { CustomTable, FilterPlaceholder } from '../../common/CustomTable';
import { FlexDiv, WideBox } from '../../styles/styles';
import { safeEval } from '../../util/UtilFunctions';
import { NumberHandler } from '../../util/NumberHandler';

const MappedPaymentsDisplay = ({
  voucher,
  paymentVouchers,
  fetchPaymentVouchers,
  fetchVoucher,
  mapPayment,
}) => {
  const history = useHistory();
  const { authStore, dataStore, orgStore } = useRootStore();
  const { isIntegrated } = orgStore;
  const [selectedPaymentVoucher, setSelectedPaymentVoucher] = useState(null);

  const deletePaymentVoucher = async () => {
    try {
      const {
        VoucherId: voucherId,
        PaymentId: paymentId,
      } = selectedPaymentVoucher;
      await authStore.request.delete(
        `${process.env.REACT_APP_API}/api/payment-voucher`,
        {
          data: { voucherId, paymentId },
        },
      );
      setSelectedPaymentVoucher(null);
      fetchVoucher();
      fetchPaymentVouchers();
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <WideBox style={{ height: 'auto', minHeight: 'auto', margin: '1rem auto' }}>
      <ConfirmDialog
        title="Delete Payment Mapping?"
        actions={({ handleClose }) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              flex: 1,
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                deletePaymentVoucher();
                handleClose();
              }}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                setSelectedPaymentVoucher(null);
                handleClose();
              }}
            >
              No
            </Button>
          </div>
        )}
      >
        {({ handleOpen }) => {
          const columns = [
            {
              Header: 'Contact',
              accessor: pV => pV.ContactName,
              id: 1,
              Filter: FilterPlaceholder,
              width: 130,
            },
            {
              Header: 'Amount',
              accessor: pV => pV.Amount,
              Cell: ({ row }) => (
                <NumberHandler
                  num={row.original.Amount}
                  float={2}
                  justify="flex-end"
                  currency="$"
                />
              ),
              id: 2,
              width: 70,
            },
            {
              Header: 'Date',
              accessor: pV => pV.SettledDate,
              width: 70,
              id: 3,
            },
            {
              Header: 'Type',
              accessor: pV => pV.TypeName,
              id: 4,
            },
            {
              Header: 'Status',
              accessor: pV => pV.StatusName,
              width: 90,
              id: 5,
            },
            {
              id: 'button',
              width: 30,
              show: !isIntegrated,
              accessor: 'delete',
              Cell: ({ row }) => (
                <IconButton
                  onClick={e => {
                    e.stopPropagation();
                    setSelectedPaymentVoucher(row.original);
                    handleOpen();
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              ),
            },
          ];
          return (
            <FlexDiv>
              <CustomTable
                data={paymentVouchers}
                columns={columns}
                disableQueryParams
                minRows={1}
                trClassName="react-table-hover-row"
                getTrProps={({ row }) => ({
                  onClick: () => {
                    const { original } = row;

                    if (original.SettlementType === 'Voucher') {
                      history.push(`/vouchers/${original.SettlementId}`);
                    } else {
                      history.push(`/payments/${original.SettlementId}`);
                    }
                  },
                })}
                tableHeader={<Typography variant="h4">Settlements</Typography>}
                actionables={
                  !isIntegrated && (
                    <Fragment>
                      <Button
                        color="primary"
                        component={Link}
                        variant="outlined"
                        style={{ marginRight: '5px' }}
                        to={{
                          pathname: '/payments/new',
                          state: {
                            ...voucher,
                          },
                        }}
                      >
                        <CirclePlusIcon
                          style={{ marginRight: '4px', marginLeft: '-3px' }}
                        />
                        New Payment
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={mapPayment}
                      >
                        Map Payment
                      </Button>
                    </Fragment>
                  )
                }
                containerStyle={{ padding: '0 2rem', width: '100%' }}
              />
            </FlexDiv>
          );
        }}
      </ConfirmDialog>
    </WideBox>
  );
};

export default MappedPaymentsDisplay;
